import styled from "styled-components";
import theme from "../theme";
import { InputHTMLAttributes, memo } from "react";

type InputProps = InputHTMLAttributes<HTMLInputElement>;

export const AlertModalInput = memo(({ ...props }: InputProps) => {
  return <ModalInput {...props} />;
});

const ModalInput = styled.input`
  width: 330px;
  height: 54px;
  background: ${theme.color.white};
  border: 1px solid ${theme.color.neutral_300};
  border-radius: 3px;
  font-weight: 400;
  font-size: 15px;
  line-height: 19px;
  color: ${theme.color.neutral_400};
  padding-left: 20px;
  margin-top: 10px;

  @media (max-width: ${theme.screen.md}px) {
    width: 100%;
    height: 30px;
    font-size: 12px;
    margin-top: 0px;
  }
`;
